import React from 'react';
import p from './phrases';
import * as e from '../elements';

export default {
  name: 'Right-aligned Cover',
  description: 'Effective against backdrops where the subject of the image is skewed towards the left',
  thumb: 'cover-right-text',
  tags: ['Cover', 'CTA'],
  jsx: (
    <e.PBlock
      pad="hi"
      height="full"
      backgroundImage="https://lh3.googleusercontent.com/KXd8sUITCouaqj6b5LsKkqyPmB2zN5AtxlDc_2dxvEZHtlaK_mjSsrHOZyzuQv0IecH3zckbWSghJlPZ99I6Zw"
    >
      <div className="row align-items-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-4 ml-auto text-right">
          <e.PText
            size="header-h2" color="primary" className="my-3"
            text={p.coverCompanyTitle}
          />
          <e.PText
            color="black-hi" size="subheader-md" className="my-3"
            text={p.coverCompanySlogan}
          />
          <e.PText
            color="black-md" size="text-lg" className="my-3"
            text={p.coverCompanyDescription}
          />
          <e.PButton
            text={p.coverCompanyBtnLabel}
            className="my-3" size="md" color="primary"
            targetType="phone"
            targetPhone={p.contactPhoneDummy}
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverRightText.jsx